import React from 'react';
import PropTypes from 'prop-types';
import ChannelItem from './components/ChannelItem';
import Style from './ChannelList.module.scss';

const ChannelList = ({ breakpoint, collectionLength, panel, verticalPosition }) => {
  const { headline, recommended } = panel;
  const channels = panel.items.member;

  return (
    <div className={Style.channelPanel}>
      {headline ? <h2 className={Style.headline}>{headline}</h2> : <div className={Style.spacer} />}
      <div className={Style.channelList}>
        {channels.map((channel, index) => (
          <ChannelItem
            breakpoint={breakpoint}
            channel={channel}
            collectionId={panel?.id}
            collectionLength={collectionLength}
            headline={headline}
            horizontalPosition={index + 1}
            isRecommended={recommended}
            key={channel.name}
            playlistLength={channels?.length}
            verticalPosition={verticalPosition}
          />
        ))}
      </div>
    </div>
  );
};

ChannelList.propTypes = {
  breakpoint: PropTypes.string,
  collectionLength: PropTypes.number,
  panel: PropTypes.shape({}),
  verticalPosition: PropTypes.number,
};

export default ChannelList;
